/**
Akhila 04/03/2023 2701350359 Added validation for corporate name and site name
Akhila 04/04/2023 2701350359 bug fixed prepopulate issue
Sohel 04/04/2023 2698811066 Change Company Type Dropdown Value
Akhila 04/04/2023 2698811066 bug fix validation and type prepopulation issue fix
Guru Prasad 04/04/2023 2698811066 fixed columns based on conditions
Sohel 04/04/2023 2698811066 Change Dropdown Values
Sohel 04/04/2023 2698811066 Fixed Phase Dropdown Issue
Sohel 04/05/2023 2698811066 Client Code Dropdown Value Changes
Sohel 04/07/2023 2699823790 Client Code and Site Name Prepopulate issue
Sohel 04/17/2023 2699823790 Added Corporate Value Based on Company
Sohel 04/17/2023 2699823790 Fixed Corporate Populate Issue
Sohel 04/18/2023 2699823790 Fixed disabled field Issue
Prakash 24/04/2023 2699823790 fixed button speacing issue
Sohel 05/24/2023 2699823790 changed validation message
Sohel 05/24/2023 2699823790 changed client code label
Ravi 06/14/2023 2699823790 rename Revone to RevOne
Sohel 12/05/2023 2700271704 Trigger field removed grey color  
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Formik} from 'formik';
import {
  Button,
  FormHelperText,
  Grid,
  TextField,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import SearchEventTactics from '../AddAgencyClient/SearchEventTactics';
import {Search, Clear, ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import BreadCrums from '../../../../../util/BreadCrum';
import {Alert} from '@material-ui/lab';
import {
  fetchClientNumberData,
  fetchCorporateNameData,
  fetchSiteNameData,
  resetClientNumber,
  resetCorporateName,
  resetSiteName,
} from '../../../../../redux/reducers/TriggerGroup';


const groupTypeDropdownValues = [
  {key: 'Corporate', value: 'Corporate'},
  {key: 'Site', value: 'Site'},
  {key: 'Department', value: 'Department'},
  {key: 'RevOne Company', value: 'RevOne Company'},
];
const AddClientForm = ({
  setClientFormData,
  clientFormData,
  setClientForm,
  clientRowData,
  setIsEdit,
  isEdit,
  setLabel,
  label,
  setDeletedGroupClientPhase,
  getValues,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {triggerGroupData, siteNameData, clientNumberData, corporateNameData} =
    useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {companyAPIdata} = useSelector(({organization}) => organization);

  const dispatch = useDispatch();
  const [searchEventTactics, setSearchEventTactics] = useState(false);
  const [disabled, setdisabled] = useState(false);
  const [selectedEventTrigger, setSelectedEventTrigger] = useState([]);
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item?.clientNumber === option ||
          item.key === option ||
          item?.corporateName === option ||
          item?.siteName === option ||
          item?.companyName === option ||
          item?.companyId === option
        ) {
          label = item;
        }
      });
    return label;
  };
  const initialVal = {
    clientCode:
      isEdit && clientRowData && clientRowData.clientCode ?
        getObjects(clientRowData?.clientCode, clientNumberData) :
        '',

    phase:
      isEdit && clientRowData && clientRowData?.phase ?
        getObjects(clientRowData?.phase, companyAPIdata) :
        null,
    eventTactic: isEdit && clientRowData ? clientRowData?.eventTactic?.join(', ') : '',
    type:
      isEdit && clientRowData?.type && clientRowData?.type ?
        getObjects(clientRowData?.type, groupTypeDropdownValues) :
        null,
    corporateName:
      isEdit && clientRowData && clientRowData?.corporateName ?
        getObjects(clientRowData?.corporateName, corporateNameData) :
        '',
    siteName:
      isEdit && clientRowData && clientRowData?.siteName ?
        getObjects(clientRowData?.siteName, siteNameData) :
        '',
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const formRef = useRef();
  const [unique, setUnique] = useState(false);

  const handleEventTacticSearch = () => {
    setSearchEventTactics(false);
  };

  useEffect(() => {
    setSelectedEventTrigger(isEdit && clientRowData ? clientRowData?.eventTactic : []);
  }, [isEdit]);

  const schema = Yup.object().shape({
    clientCode:
      label === 'Department' ?
        Yup.mixed().test('clientCode', 'Department is required', (value) => {
          if (!value?.clientNumber) {
            return false;
          } else {
            return true;
          }
        }) :
        null,

    phase: Yup.mixed().test('phase', 'Company is required', (value) => {
      //  formRef.current?.values?.type?.value !== "Corporate" &&
      // formRef.current?.values?.type?.value !== "Site" &&
      if (!value?.companyName) {
        return false;
      } else {
        return true;
      }
    }),
    type: Yup.mixed().test('type', 'Type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    eventTactic: Yup.mixed().test('type', 'Triggers is required', (value) => {
      if (selectedEventTrigger?.length > 0) {
        return true;
      } else {
        return false;
      }
    }),
    corporateName:
      formRef.current?.values?.type?.value !== 'RevOne Company' &&
      Yup.mixed().test('corporateName', 'Corporate Name is required', (value) => {
        if (!value?.corporateName) {
          return false;
        } else {
          return true;
        }
      }),
    siteName:
      formRef.current?.values?.type?.value !== 'RevOne Company' &&
      formRef.current?.values?.type?.value !== 'Corporate' &&
      Yup.mixed().test('siteName', 'Site Name is required', (value) => {
        if (!value?.siteName) {
          return false;
        } else {
          return true;
        }
      }),
  });

  const getEventTriggerData = (data) => {
    return data?.length > 0 ? data?.map((i) => i?.code)?.toString() : [];
  };

  const handleSubmit = (values) => {
    const obj = {};
    if ('triggerCodePhaseList' in clientRowData) {
      clientRowData.triggerCodePhaseList.forEach((el) => {
        obj[el.triggerCode] = el;
      });
    }
    const data = {
      ...values,
      clientCode: values?.clientCode?.clientNumber ? values?.clientCode?.clientNumber : '',

      corporateName: values?.corporateName?.corporateName ?
        values?.corporateName?.corporateName :
        '',
      siteName: values?.siteName?.siteName ? values?.siteName?.siteName : '',
      eventTactic:
        selectedEventTrigger?.map((el) => {
          if (obj[el.code]) {
            el.groupClientPhaseId = obj[el.code].groupClientPhaseId;
          }
          return el;
        }) || [],
      phase: values?.phase?.companyId ? values?.phase?.companyId : null,
      type: values?.type?.value ? values?.type?.value : '',
    };
    if (clientRowData?.triggerCodePhaseList?.length > 0) {
      const getDifference = () => {
        return clientRowData?.triggerCodePhaseList?.filter((object1) => {
          return !data?.eventTactic?.some((object2) => {
            return object1?.groupClientPhaseId === object2?.groupClientPhaseId;
          });
        });
      };
      const deleteData = getDifference().map((i) => i?.groupClientPhaseId);
      setDeletedGroupClientPhase(deleteData);
    }
    const copyData = [...clientFormData];
    if (!isEdit) {
      copyData.push({...data});
      const cleanArray = copyData.reduce((unique, o) => {
        if (
          !unique.some((obj) => {
            if (obj?.type === 'RevOne Company') {
              return obj?.phase === o?.phase && obj.type === o.type;
            } else if (obj?.type === 'Corporate') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj?.phase === o?.phase &&
                obj.type === o.type
              );
            } else if (obj?.type === 'Site') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj?.phase === o?.phase &&
                obj.type === o.type &&
                obj.siteName === o.siteName
              );
            } else if (obj?.type === 'Department') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj.siteName === o.siteName &&
                obj.clientCode === o.clientCode &&
                obj?.phase === o?.phase
              );
            }
          })
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (copyData?.length > cleanArray?.length) {
        setUnique(true);
        setdisabled(true);
      } else {
        setClientFormData(cleanArray);
        setClientForm(false);
        setUnique(false);
      }
    } else {
      const updatedData = copyData.map((each, i) => {
        const {tableData} = clientRowData;
        if (each.tableData?.id === tableData?.id) {
          return {
            ...each,
            clientCode: data?.clientCode || '',
            corporateName: data?.corporateName ? data?.corporateName : '',
            siteName: data?.siteName ? data?.siteName : '',
            eventTactic: data?.eventTactic ? data?.eventTactic : [],
            phase: data?.phase ? data?.phase : null,
            type: data?.type ? data?.type : '',
          };
        } else {
          return {
            ...each,
          };
        }
      });
      const cleanArrays = updatedData.reduce((unique, o) => {
        if (
          !unique.some((obj) => {
            if (obj?.type === 'RevOne Company') {
              return obj?.phase === o?.phase && obj.type === o.type;
            } else if (obj?.type === 'Corporate') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj?.phase === o?.phase
              );
            } else if (obj?.type === 'Site') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj.siteName === o.siteName &&
                obj?.phase === o?.phase
              );
            } else if (obj?.type === 'Department') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj.siteName === o.siteName &&
                obj.clientCode === o.clientCode &&
                obj?.phase === o?.phase
              );
            }
          })
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (copyData?.length > cleanArrays?.length) {
        setUnique(true);
        setdisabled(true);
      } else {
        setClientFormData(updatedData);
        setIsEdit(false);
        setUnique(false);
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setdisabled(false);
    }, 500);
  }, [unique]);

  useEffect(() => {
    if (isEdit && ['Site', 'Department']?.includes(clientRowData?.type)) {
      const corporateId = getObjects(clientRowData?.corporateName, corporateNameData)?.corporateId;

      if (corporateId) {
        dispatch(fetchSiteNameData(corporateId));
      }
      // setInitialValues({
      //   ...initialVal,
      //   siteName: getObjects(clientRowData?.siteName, siteNameData),
      // });
    } else if (isEdit && ['Corporate']?.includes(clientRowData?.type)) {
      setInitialValues({
        ...initialVal,
        corporateName:
          isEdit && clientRowData && clientRowData?.corporateName ?
            getObjects(clientRowData?.corporateName, corporateNameData) :
            '',
      });
    }
  }, [clientRowData, corporateNameData]);
  useEffect(() => {
    if (isEdit && ['Department']?.includes(clientRowData?.type)) {
      const siteId = getObjects(clientRowData?.siteName, siteNameData)?.siteId;
      if (siteId) {
        dispatch(fetchClientNumberData(siteId));
      }
    }
  }, [clientRowData, siteNameData]);
  useEffect(() => {
    if (isEdit && ['Site', 'Department']?.includes(clientRowData?.type)) {
      setInitialValues({
        ...initialVal,
        clientCode: getObjects(clientRowData?.clientCode, clientNumberData),
        siteName: getObjects(clientRowData?.siteName, siteNameData),
        corporateName: formRef?.current?.values?.corporateName || '',
      });
    }
  }, [clientRowData, clientNumberData, siteNameData]);
  useEffect(() => {
    if (isEdit && clientRowData?.corporateName) {
      setInitialValues({
        ...initialVal,
        corporateName: getObjects(clientRowData?.corporateName, corporateNameData) || '',
      });
    }
  }, [corporateNameData]);
  useEffect(() => {
    if (isEdit && !['RevOne Company']?.includes(clientRowData?.type)) {
      const companyId = getObjects(clientRowData?.phase, companyAPIdata)?.companyId;
      if (companyId) {
        dispatch(fetchCorporateNameData(companyId));
      }
    }
  }, [clientRowData, companyAPIdata]);
  return (
    <div className={classes.addRule}>
      <div className={`new-standard-textfields ${classes.dialoguecardStyles}`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
          validateOnChange
          innerRef={formRef}
        >
          {(props) => {
            const {
              values,

              handleSubmit,
              setFieldValue,
              handleReset,
              handleChange,
              touched,
              errors,
              resetForm,
              handleBlur,
            } = props;
            return (
              <>
                {searchEventTactics ? (
                  <>
                    <div className="new-standard-textfields form-group">
                      <Button
                        variant="text"
                        className={`"mb-2 search-btn  ${classes.buttonRoot}"`}
                        onClick={() => {
                          setSearchEventTactics(false);
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Go Back
                      </Button>
                    </div>
                    <SearchEventTactics
                      handleClose={handleEventTacticSearch}
                      setSelectedEventTrigger={setSelectedEventTrigger}
                      selectedEventTrigger={selectedEventTrigger}
                      searchEventTactics={searchEventTactics}
                      setSearchEventTactics={setSearchEventTactics}
                      //  tacticValue={getValues()?.eventTactic}
                    />
                  </>
                ) : (
                  <div>
                    {unique && (
                      <Alert className="mb-2" severity="error">
                        {values?.type?.value === 'RevOne Company'
                          ? 'Company and Triggers Combination already exists'
                          : values?.type?.value === 'Corporate'
                            ? 'Corporate and Triggers Combination already exists'
                            : values?.type?.value === 'Site'
                              ? 'Site and Triggers Combination already exists'
                              : values?.type?.value === 'Department'
                                ? 'Department and Triggers Combination already exists'
                                : ''}
                      </Alert>
                    )}
                    <BreadCrums
                      name={' Batch Trigger Name'}
                      code={triggerGroupData?.groupCode}
                      description={'Batch Trigger Description'}
                      descriptionValue={triggerGroupData?.groupDescription}
                    />
                    <form
                      autoComplete="off"
                      noValidate
                      onSubmit={handleSubmit}
                      onReset={handleReset}
                    >
                      <div className="mt-2 global-field-textfields new-standard-textfields">
                        <ErrorBoundaryForComponents>
                          <Grid container spacing={2}>
                            <Grid item xs={4} className="form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="type"
                                id="type"
                                size="small"
                                value={values.type}
                                options={groupTypeDropdownValues}
                                disabled={isEdit}
                                getOptionDisabled={(option) => option?.valueCode === 'none'}
                                getOptionLabel={(option) => {
                                  return option && option.value
                                    ? option?.valueCode === null
                                      ? option?.value
                                      : option?.value
                                    : '';
                                }}
                                required
                                onChange={(e, value) => {
                                  setFieldValue('type', value);
                                  setLabel(value?.value);
                                  if (!isEdit) {
                                    setFieldValue('clientCode', '');
                                    // setFieldValue("correspondingClients", "");
                                    setFieldValue('phase', null);
                                    setSelectedEventTrigger([]);
                                  }
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      className={` ${classes.labelName}`}
                                      error={Boolean(touched?.type && errors?.type)}
                                      variant="outlined"
                                      margin="dense"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      required
                                      label="Type"
                                      placeholder="Select Type"
                                      // className={` ${classes.labelName} ${classes.selectLabel}`}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText>
                                {touched?.type && errors?.type && errors?.type}
                              </FormHelperText>
                            </Grid>

                            {values?.type?.value && (
                              <>
                                <Grid item xs={4} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name={`phase`}
                                    id={`phase`}
                                    size="small"
                                    value={values?.phase}
                                    freeSolo
                                    options={companyAPIdata}
                                    disabled={
                                      isEdit && !['RevOne Company']?.includes(clientRowData?.type)
                                    }
                                    getOptionLabel={(option) => {
                                      return option.companyName ? option.companyName : '';
                                    }}
                                    required
                                    onChange={(e, value) => {
                                      dispatch(resetSiteName());
                                      dispatch(resetClientNumber());
                                      dispatch(resetCorporateName());
                                      setFieldValue('clientCode', '');
                                      setFieldValue('siteName', '');
                                      setFieldValue('corporateName', '');
                                      setFieldValue(`phase`, value);
                                      if (
                                        value?.companyId &&
                                        values?.type?.value !== 'RevOne Company'
                                      ) {
                                        dispatch(fetchCorporateNameData(value?.companyId));
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          className={` ${classes.labelName}`}
                                          {...params}
                                          variant="outlined"
                                          margin="dense"
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          required
                                          label="Company"
                                          error={Boolean(touched?.phase && errors?.phase)}
                                          placeholder="Select Company"
                                          // className={` ${classes.labelName} ${classes.selectLabel}`}
                                        />
                                      </div>
                                    )}
                                  />

                                  <FormHelperText style={{ color: 'red' }}>
                                    {touched.phase && errors.phase}
                                  </FormHelperText>
                                </Grid>
                              </>
                            )}

                            {(values?.type?.value === 'Corporate' ||
                              values?.type?.value === 'Site' ||
                              values?.type?.value === 'Department') && (
                              <>
                                <Grid item xs={4} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="corporateName"
                                    id="corporateName"
                                    size="small"
                                    value={values?.corporateName}
                                    options={corporateNameData || []}
                                    getOptionLabel={(option) => {
                                      return option.corporateName || '';
                                    }}
                                    freeSolo
                                    onChange={(e, value) => {
                                      dispatch(resetSiteName());
                                      dispatch(resetClientNumber());
                                      setFieldValue('clientCode', '');
                                      setFieldValue('siteName', '');
                                      if (
                                        value?.corporateId &&
                                        ['Site', 'Department']?.includes(values?.type?.value)
                                      ) {
                                        dispatch(fetchSiteNameData(value?.corporateId));
                                      }
                                      setFieldValue('corporateName', value);
                                    }}
                                    renderInput={(params) => (
                                      <div className="select-field close-icon">
                                        <GuiTextField
                                          {...params}
                                          className={` ${classes.labelName}`}
                                          variant="outlined"
                                          margin="dense"
                                          required
                                          error={Boolean(
                                            touched.corporateName && errors.corporateName,
                                          )}
                                          label="Corporate Name"
                                          placeholder="Select Corporate Name"
                                        />
                                      </div>
                                    )}
                                  />
                                  <FormHelperText style={{ color: 'red' }}>
                                    {touched.corporateName &&
                                      errors?.corporateName &&
                                      errors.corporateName}
                                  </FormHelperText>
                                </Grid>
                              </>
                            )}
                            {(values?.type?.value === 'Site' ||
                              values?.type?.value === 'Department') && (
                              <>
                                <Grid item xs={4} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="siteName"
                                    id="siteName"
                                    size="small"
                                    value={values.siteName}
                                    freeSolo
                                    options={siteNameData || []}
                                    getOptionLabel={(option) => {
                                      return option.siteName || '';
                                    }}
                                    onChange={(e, value) => {
                                      dispatch(resetClientNumber());
                                      setFieldValue('clientCode', '');
                                      if (
                                        value?.siteId &&
                                        ['Department']?.includes(values?.type?.value)
                                      ) {
                                        dispatch(fetchClientNumberData(value?.siteId));
                                      }
                                      setFieldValue('siteName', value);
                                    }}
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          className={` ${classes.labelName}`}
                                          {...params}
                                          variant="outlined"
                                          margin="dense"
                                          required
                                          error={Boolean(touched.siteName && errors.siteName)}
                                          label="Site Name"
                                          placeholder="Select Site Name"
                                        />
                                      </div>
                                    )}
                                  />
                                  <FormHelperText style={{ color: 'red' }}>
                                    {touched.siteName && errors?.siteName && errors.siteName}
                                  </FormHelperText>
                                </Grid>
                              </>
                            )}
                            {values?.type?.value === 'Department' && (
                              <>
                                <Grid item xs={4} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="clientCode"
                                    id="clientCode"
                                    size="small"
                                    value={values.clientCode}
                                    freeSolo
                                    options={clientNumberData || []}
                                    getOptionLabel={(option) => {
                                      return option?.clientNumber ? option?.clientNumber : '';
                                    }}
                                    required
                                    onChange={(e, value) => {
                                      setFieldValue('clientCode', value);
                                    }}
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          className={` ${classes.labelName}`}
                                          {...params}
                                          error={Boolean(touched.clientCode && errors.clientCode)}
                                          variant="outlined"
                                          margin="dense"
                                          required
                                          label="Department"
                                          placeholder="Select Department"
                                        />
                                      </div>
                                    )}
                                  />
                                  <FormHelperText>
                                    {touched.clientCode && errors.clientCode && errors.clientCode}
                                  </FormHelperText>
                                </Grid>
                              </>
                            )}
                            {values?.type?.value && (
                              <Grid item xs={4} className="form-group wait-date-disable-field">
                                <TextField
                                  margin="dense"
                                  className={` ${classes.labelName}`}
                                  variant="outlined"
                                  placeholder={`Enter Triggers`}
                                  label="Triggers"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  name="eventTactic"
                                  value={getEventTriggerData(selectedEventTrigger)}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('eventTactic', e.target.value);
                                  }}
                                  fullWidth
                                  handleBlur={handleBlur}
                                  required
                                  touched={touched?.eventTactic}
                                  error={
                                    selectedEventTrigger?.length > 0
                                      ? null
                                      : Boolean(touched?.eventTactic && errors?.eventTactic)
                                  }
                                  disabled
                                  InputProps={{
                                    endAdornment: (
                                      // Added tooltip (2700430604)
                                      <InputAdornment position="end">
                                        <Tooltip title={'Search'}>
                                          <Search
                                            className={` ${classes.iconSearch}`}
                                            onClick={() => setSearchEventTactics(true)}
                                            size="sm"
                                          />
                                        </Tooltip>
                                        <Tooltip title={'Clear'}>
                                          <Clear
                                            className={` ${classes.iconSearch}`}
                                            // Clear Event Trigger data(2700430604)
                                            onClick={(e) => setSelectedEventTrigger([])}
                                          />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <FormHelperText style={{ color: 'red' }}>
                                  {selectedEventTrigger?.length > 0
                                    ? null
                                    : touched?.eventTactic && errors?.eventTactic}
                                </FormHelperText>
                              </Grid>
                            )}
                          </Grid>
                        </ErrorBoundaryForComponents>
                      </div>
                      <div className="d-flex justify-content-center new-standard-textfields">
                        <Button
                          variant="outlined"
                          onClick={() => {
                            resetForm(initialValues);
                            !isEdit && setLabel('');
                            setSelectedEventTrigger(
                              isEdit && clientRowData ? clientRowData?.eventTactic : [],
                            );
                          }}
                          disbled={disabled}
                          className={`mx-1 reset-btn ${classes.buttonRoot}`}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                          disbled={disabled}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                )}
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddClientForm;
